import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { SAVED_FILTERS_QUERY_KEYS } from 'app/modules/filters/queries/keys';
import { FilterContext } from 'app/modules/filters/models';
import { destroy } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';

export const useDeleteSavedFilter = (filterContext: FilterContext) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => destroy<void>(`/v1/saved-filters/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SAVED_FILTERS_QUERY_KEYS.list(filterContext),
      });
      dispatch(sendSuccessToast('Successfully deleted saved filter.'));
    },
    onError: () =>
      dispatch(
        sendErrorToast('Failed to delete saved filter. Please try again.'),
      ),
  });
};
